import { render, staticRenderFns } from "./AddTripConfig.vue?vue&type=template&id=44d340cd&"
import script from "./AddTripConfig.vue?vue&type=script&lang=js&"
export * from "./AddTripConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports